
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.593 14.871V3.721H0v11.15c0 .876.717 1.593 1.593 1.593h11.15v-1.593H1.593z"}}),_c('path',{attrs:{"d":"M14.336.536H4.778c-.876 0-1.592.716-1.592 1.593v9.557c0 .876.716 1.593 1.592 1.593h9.558c.876 0 1.592-.717 1.592-1.593V2.129c0-.877-.716-1.593-1.592-1.593zM7.964 6.907c0 .398-.398.797-.796.797H6.37v1.592h-.796V5.314h1.593c.398 0 .796.398.796.797v.796zM11.15 8.5c0 .398-.398.796-.797.796H8.761V5.314h1.592c.399 0 .797.398.797.797V8.5zm2.39-2.39h-.797v.797h.796v.797h-.796v1.592h-.797V5.314h1.593v.797z"}}),_c('path',{attrs:{"d":"M10.354 6.11h-.797V8.5h.797V6.11zm-3.186 0h-.796v.797h.796v-.796z"}})])
          )
        }
      }
    